import { render } from "./ExtensionRecordView.vue?vue&type=template&id=2235db5b&scoped=true&ts=true"
import script from "./ExtensionRecordView.vue?vue&type=script&lang=ts"
export * from "./ExtensionRecordView.vue?vue&type=script&lang=ts"

import "./ExtensionRecordView.vue?vue&type=style&index=0&id=2235db5b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2235db5b"]])

export default __exports__